import { useCatalogSearch } from "@shared/hooks/useCatalogSearch";

const useHasCatalogSearchShared = () => {
  const {
    activeIngredients,
    excludedIngredients,
    activeBrands,
    activeSupplementTypes,
    activeConditions,
    activeFilters,
    searchQuery,
    isOnlyShowInStock,
    isOnlyShowFavorites,
  } = useCatalogSearch();

  return (
    searchQuery ||
    activeBrands?.length > 0 ||
    activeIngredients?.length > 0 ||
    excludedIngredients?.length > 0 ||
    activeFilters?.length > 0 ||
    activeSupplementTypes?.length > 0 ||
    activeConditions?.length > 0 ||
    isOnlyShowInStock ||
    isOnlyShowFavorites
  );
};

export { useHasCatalogSearchShared };
